import { getParameterByName } from '@hotjar/webapp/features/Playbacks/store/utils';
import { Store } from '../../../store/player/types';
import { fetchUserData } from './fetchUserData';
import { whenFetchRecordingReady } from './whenFetchRecordingReady';
import { fetchRecordingData } from './fetchRecordingData';
import { setRetakerSettings } from './setRetakerSettings';

export const initialize = async (store: Store): Promise<void> => {
  const {
    siteId,
    recordingId,
    isHighlightMode,
    isRetakerMode,
    setDebugEvents,
    setLoaded,
    setPlaybacksOpener,
  } = store.getState();
  // If the recording was opened from the recordings list,
  // check if we have any data we want to read from cookies
  // that the recordings list set for us.

  const opener = getParameterByName('opener');
  if (opener) {
    setPlaybacksOpener(opener);
    // Clear the opener parameter as it's no longer needed.
    history.replaceState &&
      history.replaceState(
        null,
        '',
        location.pathname + location.search.replace(/[?&]opener=[^&]+/, '').replace(/^&/, '?'),
      );
  }

  // Turn on debugging if we specified '?debug=X' in the URL.
  // Option 1: Show debugging info for all events: ?debug=all
  // Option 2: Show debugging info for any events you specify:
  // ?debug=key_press,select_change,input_choice_change,mouse_move,mouse_click,scroll,mutation
  if (getParameterByName('debug') === 'all') {
    setDebugEvents();
  } else if (getParameterByName('debug').length) {
    setDebugEvents(getParameterByName('debug').split(','));
  }

  if (!(siteId && recordingId)) {
    // We can't load a recording without the IDs and token. Set it to 'loaded' and abort.
    setLoaded();
  } else {
    // Enrich the page title with the recording id.
    // By default the title contains only `Recording`.
    window.document.title = `Recording ${recordingId}`;

    // Heatmap Screenshot Retaker events to allow picking custom time from Recording
    if (isRetakerMode) {
      setRetakerSettings(store);
    }

    whenFetchRecordingReady(() => fetchRecordingData(store));
    await fetchUserData(store);
  }

  // Record the recording. Site 14 is excluded as we don't want to record ourselves.
  if (siteId !== 14 && !isHighlightMode) {
    window.injectHotjarTrackingCode();
  }
};
